import {BrowserRouter as Router, Routes, Route, useLocation} from 'react-router-dom';
import {AppHeader} from "./components/base/AppHeader";
import {AppFooter} from "./components/base/AppFooter";
import {TermsOfService} from "./pages/TermsOfService";
import {PrivacyPolicy} from "./pages/PrivacyPolicy";
import {NotFound404} from "./pages/404NotFound";
import {HomePage} from "./pages/HomePage";

export const App = () => {
    return (
        <Router>
            <MyRoutes />
        </Router>
    )
};


const MyRoutes = ()=> {

    const excludeFooterPaths = useLocation().pathname === "/lolol";
    const excludedHeaderPaths = useLocation().pathname === "/lolol";

    return(
    <>
        {excludedHeaderPaths ? <></> : <AppHeader />}
        <Routes>
            <Route path="/" element={<HomePage />}/>
            <Route path="/*" element={<NotFound404/>}/>
        </Routes>

        {excludeFooterPaths ? <></> : <AppFooter />}
    </>
    );
};




